import { render, staticRenderFns } from "./CalculatorModule.vue?vue&type=template&id=0896db40"
import script from "./CalculatorModule.vue?vue&type=script&lang=js"
export * from "./CalculatorModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports